import LayoutApp from "@lhd/components/CloneApp/LayoutApp";
import { convertDataToDataForm } from "@lhd/components/CloneApp/untils";
import { AppRecordV2, AppV2, AppSelectionList } from "@lhd/types";
import { Form } from "antd";
import { useMemo } from "react";
import { Styles } from "./styled";

interface IProps {
  dataApp: AppV2;
  appRecord: AppRecordV2;
  selectionDataList?: AppSelectionList;
}

const AgreementsPDF = ({ dataApp, appRecord, selectionDataList }: IProps) => {
  const [form] = Form.useForm();
  const appType = dataApp?.app_type;

  const filteredDataApp = useMemo(() => {
    if (!dataApp?.app_parts) return dataApp;

    // Identify tables to hide or resize
    const referenceTablePart = dataApp.app_parts.find(
      (part) => part.app_part_type === "table" && part.name === "参考資料",
    );
    const referenceTableId = referenceTablePart?.id;

    const mainTablePart = dataApp.app_parts.find(
      (part) => part.app_part_type === "table" && part.name === "テーブル",
    );

    let allowedMainTableColumnIds: string[] = [];
    let allMainTableColumnIds: string[] = [];
    let totalAllowedColumnWidth = 0;

    if (mainTablePart) {
      // Get all columns of the main table ordered by X coordinate
      const mainTableColumns = dataApp.app_parts
        .filter(
          (part) =>
            String(part.parent_id) === String(mainTablePart.id) ||
            String(part.app_part_relation_id) === String(mainTablePart.id),
        )
        .map((col: any) => {
          let xCoord = 0;
          if (col.item_config_data) {
            try {
              xCoord = JSON.parse(col.item_config_data as string).x;
            } catch (e) {
              // Ignore parse errors
            }
          }
          return { id: col.id, x: xCoord };
        })
        .sort((a, b) => a.x - b.x);

      allMainTableColumnIds = mainTableColumns.map((col: any) => col.id);

      // Limit to first 5 columns
      const allowedColumns = mainTableColumns.slice(0, 5);
      allowedMainTableColumnIds = allowedColumns.map((col: any) => col.id);

      // Calculate total width of allowed columns
      allowedColumns.forEach((col: any) => {
        const part = dataApp.app_parts.find((ap) => ap.id === col.id) as any;
        if (part && part.item_config_data) {
          try {
            const config =
              typeof part.item_config_data === "string"
                ? JSON.parse(part.item_config_data)
                : part.item_config_data;
            let colWidth = config.w || 1;
            if (part.app_part_type === "number") colWidth = 7;
            totalAllowedColumnWidth += colWidth;
          } catch (e) {
            // Ignore parse errors
          }
        }
      });
    }

    const fieldNamesToHide = [
      "カテゴリー",
      "ステータス",
      "更新日付",
      "<h2>参考資料・考察記録</h2>",
      "出力PDF等添付ファイル",
      "参考資料",
      "全般 協議/課題MEMO",
      "横罫線",
    ];

    const filteredAppParts = dataApp.app_parts
      .filter((part) => {
        // Hide children of the reference table
        if (
          referenceTableId &&
          (String(part.app_part_relation_id) === String(referenceTableId) ||
            String(part.parent_id) === String(referenceTableId))
        ) {
          return false;
        }

        // Hide excluded columns of the main table
        if (
          part.id &&
          allMainTableColumnIds.includes(part.id) &&
          !allowedMainTableColumnIds.includes(part.id)
        ) {
          return false;
        }

        // Hide specific top-level fields
        if (part.name && fieldNamesToHide.includes(part.name)) {
          return false;
        }

        return true;
      })
      .map((part: any) => {
        if (part.item_config_data) {
          try {
            const config = JSON.parse(part.item_config_data);
            let hasChanged = false;

            // Shift items up vertically
            if (config.y !== undefined && config.y !== null) {
              config.y = Number(config.y) - 10;
              hasChanged = true;
            }

            // Scale column width
            if (allowedMainTableColumnIds.includes(part.id)) {
              config.w = (config.w || 1) * 1.15;
              hasChanged = true;
            }

            // Recalculate main table width to fit remaining columns
            if (
              mainTablePart &&
              part.id === mainTablePart.id &&
              totalAllowedColumnWidth > 0
            ) {
              config.w = Math.ceil(totalAllowedColumnWidth * 1.15 + 1.15);
              hasChanged = true;
            }

            // Scale document name
            if (part.app_part_type === "text" && part.name === "書面名") {
              config.w = (config.w || 1) * 0.85;
              hasChanged = true;
            }

            if (hasChanged) {
              return {
                ...part,
                item_config_data: JSON.stringify(config),
              };
            }
          } catch (error) {
            // Ignore parse errors
          }
        }
        return part;
      });

    return {
      ...dataApp,
      app_parts: filteredAppParts,
    };
  }, [dataApp]);

  if (appRecord) {
    const result = convertDataToDataForm(
      filteredDataApp?.app_parts || [],
      appRecord,
      true,
    );
    form.setFieldsValue(result);
  }

  return (
    <Styles>
      <Form form={form} disabled>
        <LayoutApp
          form={form}
          dataApp={filteredDataApp}
          appRecord={appRecord}
          appType={appType}
          isEditPage={true}
          isEditing={false}
          isPDF={true}
          selectionDataList={selectionDataList}
        />
      </Form>
    </Styles>
  );
};

export default AgreementsPDF;
